import { httpClient } from "@/app/old/desktop/shared/services/";
import { coreBaseUrl } from "@/environment/environment";

export default class BaseService {
  constructor(api_host, url) {
    this.url = url;
    this.baseURL = api_host || coreBaseUrl;
  }
  async getAll(req = {}) {
    return httpClient({
      url: `${this.url}/${req.query ? `?${req.query}` : ""}`,
      baseURL: this.baseURL,
      headers: req.headers,
    }).then(res => res.data);
  }
  async post(req = {}) {
    return httpClient({
      url: `${this.url}/${req.id ? `${req.id}/` : ""}${
        req.attribute ? `${req.attribute}/` : ""
      }${req.query ? `?${req.query}` : ""}`,
      baseURL: this.baseURL,
      method: "post",
      data: req.body,
      headers: req.headers,
    }).then(res => res.data);
  }
  async get(req = {}) {
    return httpClient({
      url: `${this.url}/${req.id}/${req.attribute ? `${req.attribute}` : ""}${
        req.query ? `?${req.query}` : ""
      }`,
      baseURL: this.baseURL,
      headers: req.headers,
    }).then(res => res.data);
  }
  async put(req = {}) {
    return httpClient({
      url: `${this.url}/${req.id}/${req.attribute ? `${req.attribute}/` : ""}`,
      baseURL: this.baseURL,
      method: "put",
      data: req.body,
      headers: req.headers,
    }).then(res => res.data);
  }
  async patch(req = {}) {
    return httpClient({
      url: `${this.url}/${req.id}${req.attribute ? `/${req.attribute}` : ""}${
        req.query ? `?${req.query}` : ""
      }`,
      baseURL: this.baseURL,
      method: "patch",
      data: req.body,
      headers: req.headers,
    }).then(res => res.data);
  }
  async delete(req = {}) {
    return httpClient({
      url: `${this.url}/${req.id}/${req.query ? `?${req.query}` : ""}`,
      baseURL: this.baseURL,
      method: "delete",
      data: req.body,
      headers: req.headers,
    }).then(res => res.data);
  }
}
